import React from 'react';
import { FiAlertTriangle, FiRefreshCw, FiHome } from 'react-icons/fi';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-[60vh] p-8">
          <div className="max-w-md w-full bg-warm-gray/20 backdrop-blur-md rounded-3xl border border-white/10 shadow-card p-8 text-center space-y-6">
            <div className="mx-auto w-16 h-16 bg-soft-coral/20 rounded-full flex items-center justify-center">
              <FiAlertTriangle className="text-soft-coral" size={32} />
            </div>
            <div className="space-y-2">
              <h2 className="text-xl font-bold text-cream">Something went wrong</h2>
              <p className="text-sm text-cream/50">
                An unexpected error occurred. You can try again or return to the dashboard.
              </p>
            </div>
            <div className="bg-warm-dark/50 rounded-2xl p-3 border border-white/5">
              <p className="text-xs text-cream/40 font-mono break-words">If this keeps happening, please contact support.</p>
            </div>
            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleReset}
                className="px-5 py-2.5 bg-slate-blue text-warm-dark rounded-full text-sm font-bold uppercase tracking-wider hover:bg-slate-blue/80 transition-all inline-flex items-center gap-2"
              >
                <FiRefreshCw size={14} />
                Try Again
              </button>
              <a
                href="/dashboard"
                className="px-5 py-2.5 bg-warm-gray/30 text-cream/60 rounded-full text-sm font-bold uppercase tracking-wider hover:text-cream hover:bg-warm-gray/50 transition-all inline-flex items-center gap-2 border border-white/10"
              >
                <FiHome size={14} />
                Dashboard
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
